import Autocomplete, { ReactGoogleAutocompleteInputProps } from 'react-google-autocomplete'

export const extractAddressDetails = (place: google.maps.places.PlaceResult) => {
  let city: string | undefined
  let country: string | undefined
  let postal_code: string | undefined

  if (place.address_components) {
    for (const component of place.address_components) {
      if (component.types.includes('locality')) {
        city = component.long_name
      }
      if (component.types.includes('country')) {
        country = component.long_name
      }
      if (component.types.includes('postal_code')) {
        postal_code = component.long_name
      }
    }
  }
  return { city, country, postal_code }
}

export const GoogleMapInput = ({
  onSelect,
  ...props
}: ReactGoogleAutocompleteInputProps & {
  onSelect: (place: google.maps.places.PlaceResult) => void
}) => {
  return (
    <Autocomplete
      apiKey={process.env.REACT_APP_GOOGLE_MAP_API}
      onPlaceSelected={(place) => {
        onSelect(place)
      }}
      options={{
        types: ['geocode', 'establishment'], // 'address' is also a good option here
        fields: ['address_components', 'formatted_address', 'geometry.location'], // Crucial: 'address_components',
        componentRestrictions: { country: ['sg'] }
      }}
      {...props}
    />
  )
}
